import { PasswordInput } from "@mantine/core";
import { EButton } from "libs/ui";
import useProfile from "./useProfile";

function ResetPassword() {
    const {params,handleParamsChange,isLoading,savePassword,close}=useProfile();

  return (
    <div className="flex flex-col gap-3">
      <div>
        <p className="text-sm text-gray-600 mt-1">
          Please enter the password and confirm password to set your new password
        </p>
      </div>
      <form
        className="verify-form"
        onSubmit={(e) => {
          e.preventDefault();
          savePassword();
        }}
      >
        <PasswordInput
          required
          size="md"
          variant="unstyled"
          className="border-b px-2 mt-3"
          placeholder="Enter New Password"
          value={params.password}
          onChange={(e) => {
            handleParamsChange("password", e.target.value);
          }}
        />

        <PasswordInput
          required
          size="md"
          variant="unstyled"
          className="border-b px-2 mt-3"
          placeholder="Confirm New Password"
          value={params.confirmPassword}
          onChange={(e) => {
            handleParamsChange("confirmPassword", e.target.value);
          }}
        />
        <div className="flex gap-3 mt-5">
          <EButton fullWidth type="submit" size="md" loading={isLoading}>
            Reset Password
          </EButton>
        </div>
      </form>
    </div>
  );
}

export default ResetPassword;
